// useScanPage.ts
import { useEffect, useState } from 'react'
import { AppConstant } from 'AppConstant'
import { getTodayScanListAsync } from '../../../redux/flows/scanWeb'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export type CurrentScanUpload = {
  patientId: string | null
  visitId: string | null
  clinicId: string | null
  profilePic: string | null
  firstname: string | null
  lastname: string | null
  dob: string | null
}

export function useScan() {
  const dispatch = useAppDispatch()
  const todayScan = useAppSelector((state) => state.scan.scanList)
  const todayScanStatus = useAppSelector((state) => state.scan.scanListStatus)

  const [currentScanUpload, setCurrentScanUpload] = useState<CurrentScanUpload>({
    patientId: null,
    visitId: null,
    clinicId: null,
    profilePic: null,
    dob: null,
    firstname: null,
    lastname: null,
  })

  // --------------------------
  // Load scans on mount
  // --------------------------
  useEffect(() => {
    dispatch(getTodayScanListAsync({ timezone: 'America/New_York' }))
  }, [])

  // --------------------------
  // Auto-select first patient
  // --------------------------
  useEffect(() => {
    if (todayScan && todayScan.length > 0) {
      const first = todayScan[0]
      setCurrentScanUpload({
        visitId: first.id,
        patientId: first.patientId,
        clinicId: first.clinicId,
        profilePic: first.patient.user.profilePic,
        firstname: first.patient.user.firstname,
        lastname: first.patient.user.lastname,
        dob: first.patient.user.dob,
      })
    }
  }, [todayScan])

  // --------------------------
  // Patient selection handler
  // --------------------------
  function handleSelect(card: any) {
    if (currentScanUpload.visitId !== card.id) {
      setCurrentScanUpload({
        visitId: card.id,
        patientId: card.patientId,
        clinicId: card.clinicId,
        profilePic: card.patient.user.profilePic,
        firstname: card.patient.user.firstname,
        lastname: card.patient.user.lastname,
        dob: card.patient.user.dob,
      })
    }
  }

  // --------------------------
  // Logout
  // --------------------------
  function signOut() {
    localStorage.removeItem(AppConstant.ACCESS_TOKEN_SCAN_AUTH)
    localStorage.removeItem(AppConstant.CLINIC_ID)
    window.location.href = '/scan/auth'
  }

  return {
    todayScan,
    todayScanStatus,
    currentScanUpload,
    handleSelect,
    signOut,
    APIStatus,
  }
}
